const BRAND_COLOR_VARIABLES = [
  '--primary-color',
  '--primary-color-rgb',
  '--primary-gradient-rgb-color-1',
  '--primary-gradient-rgb-color-2',
];

export function hexToRgbChannels(hex) {
  const value = hex?.replace('#', '');

  if (!value || value.length !== 6) {
    return null;
  }

  return [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16)).join(' ');
}

export function applyBrandColor(primaryColor) {
  const channels = hexToRgbChannels(primaryColor);

  if (!channels) {
    return;
  }

  const style = document.documentElement.style;
  style.setProperty('--primary-color', primaryColor);
  style.setProperty('--primary-color-rgb', channels);
  style.setProperty('--primary-gradient-rgb-color-1', channels);
  style.setProperty('--primary-gradient-rgb-color-2', channels);
}

// Restores the FoodAmigos defaults from global.css by dropping the inline overrides.
export function clearBrandColor() {
  BRAND_COLOR_VARIABLES.forEach((variable) => document.documentElement.style.removeProperty(variable));
}
